import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import Base from './Base';

var Paragraph = function Paragraph(props, ref) {
  return /*#__PURE__*/React.createElement(Base, _extends({
    ref: ref
  }, props, {
    component: "div"
  }));
};

export default /*#__PURE__*/React.forwardRef(Paragraph);